import { useAuth, overrideConfig, service } from '@/api/billing-primary'

const fetchCostTags = function ({ projectIdx, month, tagKey }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('v1/context', { target: 'CostsByTag', params: { projectIdx: [projectIdx], month, tagKey } })
}

const fetchCostTagsByCategory = function ({ projectIdx, month, tagKey, tagValue }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/context', { target: 'CostsByTagCategory', params: { projectIdx: [projectIdx], month, tagKey, tagValue } })
}

const fetchCostTagsByResourceid = function ({ projectIdx, month, tagKey, tagValue, productCode, productCategory }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/context', { target: 'CostsByTagResourceId', params: { projectIdx: [projectIdx], month, tagKey, tagValue, productCode, productCategory } })
}

export default {
    ...service,
    fetchCostTags,
    fetchCostTagsByCategory,
    fetchCostTagsByResourceid
}
